export enum SegmentEnumerator {
    B2B = 'b2b',
    B2C = 'b2c',
    B2B2C = 'b2b2c'
}